module.exports = __webpack_public_path__ + "static/media/template3.bd1adce4.jpg";